// extracted by mini-css-extract-plugin
module.exports = {"work":"_1fvK4oQck2Z3Q5YudMPH0H","shadow":"_1B1WvGmK4F82H9GFwIzaC9","extended":"-uWQCklsnFmOKAjili0di"};